var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 597.4 599.899",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h597.4v599.899H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#error_svg__a)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.9.6c-11.7 1-33.8 4.9-47 8.3A298.75 298.75 0 0 0 71 105Q15.8 169.349 2.3 256.9c-2 12.5-2.3 18.4-2.3 43s.3 30.5 2.3 43c10.6 68.2 39.8 125.3 87.8 172 29.8 29.1 60.8 49.2 98.8 64.3 36 14.3 70.1 20.7 110.8 20.7 21.9 0 32.7-.8 52-4.1 78.2-13.1 150-59.2 195.9-125.9a301.55 301.55 0 0 0 47.8-116.2c1.8-10 2-15.5 2-53.8s-.2-43.8-2-53.8A300.175 300.175 0 0 0 333.9 1.4c-11.8-1.4-50-1.9-62-.8m66 27.2c42.9 6.4 79.7 20.5 114 43.6 65.9 44.4 108 111.1 120 190.5 2.3 15.2 3 44.8 1.6 61-5.1 55-24 102.8-58.1 147-8.9 11.4-32.3 35-44 44.4-30.5 24.3-70.1 43.7-107 52.6-59.7 14.3-119.7 8.6-177.8-16.7C127 524.1 74.9 471.3 48.1 409.8c-15.6-35.7-22.7-70.1-22.7-109.9 0-36.1 5.5-66.4 17.7-98 38-98.4 127.5-165.9 233.3-176 14.3-1.3 46.4-.4 61.5 1.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 178.284 178.284 150 448.06 419.776l-28.284 28.284z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m147 422.889 274.89-274.89 28.283 28.285-274.889 274.89z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export default ForwardRef;